import { useCallback, useSyncExternalStore } from "react";

export type DesktopPermission = NotificationPermission | "unsupported";

function currentPermission(): DesktopPermission {
  return typeof Notification === "undefined" ? "unsupported" : Notification.permission;
}

// The permission is per browser, not per component: the shell's banner and the
// settings page must both update when either one asks.
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useDesktopPermission() {
  const permission = useSyncExternalStore(subscribe, currentPermission);
  const request = useCallback(async (): Promise<boolean> => {
    if (typeof Notification === "undefined") return false;
    if (Notification.permission === "granted") return true;
    const result = await Notification.requestPermission();
    for (const listener of listeners) listener();
    return result === "granted";
  }, []);
  return { permission, request };
}
